import { Capacitor } from '@capacitor/core'
import { CapacitorPasskey } from '@capgo/capacitor-passkey'
import { apiHostname } from '@awork/environments/environment'

/**
 * Routes WebAuthn calls to the native passkey APIs when the app runs inside Capacitor.
 * The web view origin is not the relying party, so the shim reports the API host as origin.
 * Run this before any passkey call so `browserSupportsWebAuthn()` sees the shim.
 */
export function installNativePasskeys(): void {
  if (!Capacitor.isNativePlatform()) {
    return
  }

  CapacitorPasskey.shimWebAuthn({ origin: `https://${apiHostname}` })
}
